import React, { Component, Fragment } from "react";
import Helmet from "react-helmet";

import { sections } from "constants/dashboard";
import { Header, Logo } from "components";
import { Button } from "antd";
import { Chart, Filters } from "components/Dashboard";

import { title } from "utils";

const cachePath = "filters[dashboard]";

/**
 * Page : Dashboard
 * ---
 * Admin dashboard.
 */

class DashboardPage extends Component {
  constructor(props) {
    super(props);

    // Logiques particulières.
    // 1 - On cache la valeur des filtres pour une expérience plus fluide.
    // 2 - Pour faire un refresh optimal des charts, on incrémente this.state.refresh
    //     lorsque les charts doivent être mis à jour (changement des filtres). Cela permet
    //     de ne pas avoir à faire une comparaison d'objets dans le composant Chart (savoir
    //     si les filtres ont changés), et optimise la vitesse de refresh.
    this.tmpFilters = JSON.parse(localStorage.getItem(cachePath));
    this.state = {
      loading: false,
      filters:
        this.tmpFilters && Object.keys(this.tmpFilters).length > 0
          ? this.tmpFilters
          : {
              date:
                this.tmpFilters?.date?.length > 0
                  ? this.tmpFilters.date
                  : [
                      `${new Date().getFullYear()}-01-01`,
                      `${new Date().getFullYear()}-${
                        new Date().getMonth() + 1
                      }-${new Date().getDate() + 1}`,
                    ],
            } || {},
      refreshes: 0,
    };

    this._mounted = true;

    this.handleFiltersUpdate = this.handleFiltersUpdate.bind(this);
  }

  componentDidMount() {
    this.fetchData();
  }

  componentWillUnmount() {
    this._mounted = false;
  }

  fetchData() {
    // Service call
  }

  // Handle le update des filtres. Caching + met à jour this.state.refresh pour
  // update les charts.
  handleFiltersUpdate(filters) {
    this.setState({ filters, refreshes: this.state.refreshes + 1 }, () => {
      localStorage.setItem(cachePath, JSON.stringify(filters));
    });
  }

  render() {
    const { t } = this.props;
    const { filters, refreshes } = this.state;

    const bread = [{ text: "Tableau de bord" }];

    return (
      <Fragment>
        <Helmet>{title("Tableau de bord")}</Helmet>

        <Header
          title="Tableau de bord"
          bread={bread}
          beforeTitle={
            <Button icon="printer" className="print-btn" onClick={() => window.print()} />
          }
        />

        <div className="dashboard-page main-content">
          <div className="print-only">
            <Logo />
          </div>

          <div className="filters-wrap">
            <Filters
              defaultFilters={filters}
              handleSubmit={(filters) => this.handleFiltersUpdate(filters)}
            />
          </div>

          <div className="dashboard-graphs">
            {(sections || []).map((section, i) => (
              <section key={i}>
                {section.title && (
                  <h2 className="section-title">
                    <i>{section.title}</i>
                  </h2>
                )}
                {/* IMPORTANT : passer this.state.refreshes en props */}
                {(section.charts || []).map((chart, j) => (
                  <Chart infos={chart} refreshes={refreshes} key={j} filters={filters} />
                ))}
              </section>
            ))}
          </div>
        </div>
      </Fragment>
    );
  }
}

export default DashboardPage;
